import React, { useState } from "react";
import client from "@sanity/client";
import axios from "axios";
const sanityClient = client({
  projectId: "0idhl247",
  dataset: "production",
  token:
    "skzx0CQViU2qRjOG3COuau1pEl9cphvOhjRnM7JGHblYGgVZfn7uprLiaRrtqnYE9krLkXo7WK7XIICkCt0dSIlurQRp20wUFKLWef93XcpD44qIIspzG1Y3HMzZ7W93NzrdM4AqQmvwsdZXueDJ5rPOjtfy6UcRKMoEsvmArcybvy8Cmr6v",
});
const Booking = () => {
  const [paitentName, setPaitentName] = useState("");
  const [reason, setReason] = useState("");
  const [speciality, setSpeciality] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [to, setTo] = useState("");
  const timeInterval = {
    radiologyultrasound: "10:30AM - 4:00PM",
    pathologybloodtest: "8:30AM - 4:00PM",
    radiologydigitalxray: "8:30AM - 4:00PM",
    electrocardiogram: "8:30AM - 4:00PM",
  };
  let temp = speciality.toString().replaceAll("-", "");
  const time = timeInterval[temp];

  function sendEmail() {
    fetch(
      `https://violetconfusedtitle.saard00vfx.repl.co/send-email?name=${email}&time=${time}`
    ).catch((err) => console.error(err));
  }

  console.log(time);
  async function mutate(mutations) {
    const result = await fetch(
      `https://0idhl247.api.sanity.io/v2021-06-07/data/mutate/production`,
      {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer skzx0CQViU2qRjOG3COuau1pEl9cphvOhjRnM7JGHblYGgVZfn7uprLiaRrtqnYE9krLkXo7WK7XIICkCt0dSIlurQRp20wUFKLWef93XcpD44qIIspzG1Y3HMzZ7W93NzrdM4AqQmvwsdZXueDJ5rPOjtfy6UcRKMoEsvmArcybvy8Cmr6v`,
        },
        body: JSON.stringify(mutations),
        method: "POST",
      }
    );

    const json = await result.json();
    return json;
  }

  const mutations = {
    mutations: [
      {
        create: {
          _type: "appointment",
          paitent_name: paitentName,
          email: email,
          speciality: speciality,
          phone: to,
          gender: gender,
          address: address,
          date: time,
        },
      },
    ],
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    sendEmail();
    mutate(mutations);

    setPaitentName("");
    setEmail("");
    setReason("");
    setGender("");
    setTo("");
    setAddress("");
  };
  return (
    <div className="flex justify-center mt-5 overflow-x-hidden ">
      <div className="border-b-black/30 border-b ">
        <div className="flex justify-center">
          <p className="text-4xl text-black/70 ">Book Appointment</p>
        </div>
        <div className="mt-5 gap-10  md:max-w-7xl    md:mx-auto md:flex flex justify-center items-center border-b  py-5 ">
          {/* fiuirst */}
          <div className="flex justify-center ml-10  items-center gap-2 lg:gap-10">
            <div className="flex flex-col ">
              <p className="py-2 font-semibold">Name</p>

              <input
                placeholder="Patient Name"
                value={paitentName}
                onChange={(e) => setPaitentName(e.target.value)}
                className="outline-none rounded-lg w-[85%] border border-black/60 md:px-5 px-1 py-2"
              />
            </div>
            <div className="flex flex-col w-fit">
              <p className="py-2 font-semibold">Email</p>
              <input
                placeholder="Patient Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="outline-none w-[85%] rounded-lg border border-black/60 md:px-5 px-1 py-2"
              />
            </div>
          </div>
          <div
            onClick={!email ? null : handleSubmit}
            className="bg-orange-500 px-3 hidden md:inline rounded-lg py-1 text-white mt-8 "
          >
            <p className="py-2 rounded-lg ">SUBMIT</p>
          </div>
        </div>
        <div className=" py-5  flex justify-center ">
          <div className=" md:flex  justify-center items-center md:gap-10 gap-0 p-5 md:p-0 space-y-5 md:space-y-0 ">
            <div className="flex px-4 flex-col ">
              <p className="py-2 font-semibold">Phone</p>
              <input
                placeholder="+91578385"
                value={to}
                onChange={(e) => setTo(e.target.value)}
                className="outline-none rounded-lg border  border-black/60 px-5 py-2"
              />
            </div>
            <div className="flex justify-center gap-10 md:gap-5">
              <div className="border flex flex-col border-black/20 w-52 rounded-lg  px-4 py-2 ">
                <p className="py-2 font-semibold">Type of Test</p>
                <select
                  onChange={(e) => setSpeciality(e.target.value)}
                  value={speciality || ""}
                  className=" border border-black/30 p-3 text-sm rounded-lg outline-none sm:mt-0 mt-5"
                >
                  <option
                    className="py-2 border-b border-b-black/10"
                    value="null"
                  >
                    None
                  </option>
                  <optgroup label="Radiology">
                    <option
                      className="py-2 border-b border-b-black/10"
                      value="radiology-ultrasound"
                    >
                      Ultrasound
                    </option>
                    <option
                      className="py-2 border-b border-b-black/10"
                      value="radiology-digital-xray"
                    >
                      Digital Xray
                    </option>
                  </optgroup>
                  <optgroup label="Pathology">
                    <option
                      className="py-2 border-b border-b-black/10"
                      value="pathology-blood-test"
                    >
                      Blood Test
                    </option>
                  </optgroup>
                  <optgroup label="Electrocardiogram">
                    <option
                      className="py-2 border-b border-b-black/10"
                      value="electrocardiogram"
                    >
                      Electrocardiogram
                    </option>
                  </optgroup>
                </select>
                <p className="py-2 font-semibold">Time of appointment</p>
                <div id="result">
                  <input value={time} disabled={true} />
                </div>
              </div>

              <div className="p-2 border rounded-lg">
                <p>Gender</p>
                <select
                  className="border border-black/30 p-3 rounded-lg"
                  onChange={(e) => setGender(e.target.value)}
                  value={gender || ""}
                >
                  <option value="null">Null</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center gap-2 md:gap-10 md:py-5 px-5 overflow-hidden  ">
          <div className=" flex justify-center md:gap-10 px-4 gap-2">
            <div className="flex flex-col">
              <p className="py-2 font-semibold">Address</p>
              <textarea
                placeholder="Flat no. , Building name, Street name,  Town, Pincode"
                value={address}
                cols={40}
                rows={2}
                onChange={(e) => setAddress(e.target.value)}
                className="outline-none overflow-hidden rounded-lg w-full border border-black/60 px-5 py-2"
              />
            </div>
          </div>
        </div>
        <div className="flex justify-center mb-3">
          <div
            onClick={!email ? null : handleSubmit}
            className="bg-orange-500 px-3    md:hidden rounded-lg py-1 text-white mt-8 "
          >
            <p className="py-2 rounded-lg ">SUBMIT</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booking;
